module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10184.83c9a927.jpg";